import { WizardLoader, WizardWithoutRouter, useWizard } from '@insify/funnel-components';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useHomeLink } from '../../util/useHomeLink';
import { stepsContext } from '../hooks/useSteps';

import type { WizardStep } from '@insify/funnel-components';

const currentIndexPredicate = (steps: WizardStep[], pathname: string) =>
  steps.findIndex((step) => step.slug === pathname.split('/')[2]);

const Fallback = () => {
  const { steps, stepsAreLoading } = stepsContext.useHook();
  const { pathname } = useLocation();
  const { navigate } = useWizard();

  useEffect(() => {
    if (!stepsAreLoading) {
      const index = currentIndexPredicate(steps, pathname);

      if (index === -1) {
        // Redirect to the last available step if the current step is not found
        navigate(`${steps[steps.length - 1].slug}`);
      }
    }
  }, [steps, stepsAreLoading]);

  return <WizardLoader loading />;
};

export const Wizard = () => {
  const { steps } = stepsContext.useHook();

  const homeLink = useHomeLink();

  const leaveWizard = () => {
    window.location.href = homeLink;
  };

  return (
    <WizardWithoutRouter
      steps={steps}
      onLeave={leaveWizard}
      currentIndexPredicate={currentIndexPredicate}
      Fallback={Fallback}
    />
  );
};
